
export function isZipValid(zip) {
  return cleanZip(zip).length === 5;
}

export default function cleanZip(zip) {
  return String(zip).replace(/\D/g,'').slice(0, 5);
}